import React, { useEffect, useState } from 'react';
import {
  Box,
  HeadingText,
  GDSStyleObject,
  StackLayout,
  UtilityText,
  FormField,
} from '@leagueplatform/genesis-core';
import { AttachmentReusableComponent } from '../../../../reusable-components/attachment.component';
import { updateFormData } from '../../../helpers';

export function ReceiptsInformation(props: any) {
  const {
    errorHandling,
    nextButtonClicked,
    footerToBottom,
    setIsAttaachmentLoading,
  } = props;

  const [form, setForm] = useState({
    itemizedAttachments: [],
  });
  const [isAttachmentError, setIsAttachmentError] = useState(false);
  const [attachmentError, setAttachmentError] = useState('');

  const isValid = form.itemizedAttachments.length !== 0;
  useEffect(() => {
    footerToBottom(false);
  }, [footerToBottom]);
  useEffect(() => {
    if (form.itemizedAttachments.length > 0) {
      errorHandling(true);
    } else {
      errorHandling(false);
    }
  }, [errorHandling, form]);

  useEffect(() => {
    if (nextButtonClicked) {
      if (!isValid) {
        if (form.itemizedAttachments.length === 0) {
          setIsAttachmentError(true);
          setAttachmentError('Attachment is required.');
        }
      }
    }
  }, [nextButtonClicked, isValid, form]);

  const attachmentsAdded = (attachmentsObj: any) => {
    const nextFormState = {
      ...form,
      itemizedAttachments: attachmentsObj,
    };
    setForm(nextFormState);
    setIsAttachmentError(false);
    setAttachmentError('');
  };

  useEffect(() => {
    const pInfo = JSON.parse(sessionStorage.getItem('formData') || '{}');
    if (pInfo) {
      setForm({
        itemizedAttachments: pInfo?.itemizedAttachments || [],
      });
    }
  }, []);

  useEffect(() => {
    if (form) {
      updateFormData(form);
    }
  }, [form]);

  return (
    <StackLayout
      css={
        {
          backgroundColor: 'White',
          maxWidth: '800px',
        } as GDSStyleObject
      }
      horizontalAlignment="center"
    >
      <Box
        css={
          {
            display: 'flex',
            flexDirection: 'column',
            padding: '$three $two $two $two',
          } as GDSStyleObject
        }
      >
        <Box
          css={
            {
              display: 'flex',
              flexDirection: 'column',
              padding: '$none $two',
            } as GDSStyleObject
          }
        >
          <HeadingText
            level="1"
            size={{
              '@initial': 'xxl',
              '@mobile': 'xl',
              '@mobileLandscape': 'xl',
              '@tablet': 'xl',
              '@laptop': 'xxl',
              '@desktop': 'xxl',
            }}
          >
            Member Dental Claim Form
          </HeadingText>
        </Box>
        <Box
          css={
            {
              display: 'flex',
              flexDirection: 'column',
              padding: '$one $two',
              width: '100%',
            } as GDSStyleObject
          }
        >
          <Box
            css={
              {
                display: 'flex',
                flexDirection: 'column',
              } as GDSStyleObject
            }
          >
            <HeadingText
              level="3"
              size={{
                '@initial': 'xl',
                '@mobile': 'lg',
                '@mobileLandscape': 'lg',
                '@tablet': 'xl',
                '@laptop': 'xl',
                '@desktop': 'xl',
              }}
              data-testid="step5"
            >
              Step 5: Receipts for Services Provided
            </HeadingText>
          </Box>
          <Box
            css={
              {
                display: 'flex',
                maxWidth: '600px',
                padding: '$one $none',
              } as GDSStyleObject
            }
          >
            <UtilityText>
              Attach any receipts, bills, or supporting claim documentation you
              may have received from your dentist. You will not be able to
              submit the form without required attachments.
            </UtilityText>
          </Box>
          <Box
            css={
              {
                display: 'flex',
                flexDirection: 'column',
                padding: '$one $none',
              } as GDSStyleObject
            }
          >
            <FormField
              id="itemizedAttachment"
              label=""
              statusIconLabel="Error"
              inputStatus={isAttachmentError ? 'error' : undefined}
              statusMessage={isAttachmentError ? attachmentError : ''}
            >
              <AttachmentReusableComponent
                displayText="Attach Itemized Bill or Receipt"
                acceptTypes={['.pdf', '.doc', '.png', '.gif', '.jpg']}
                onUpdate={attachmentsAdded}
                attachments={form.itemizedAttachments}
                serviceIndex="dental-receipt"
                setIsAttaachmentLoading={setIsAttaachmentLoading}
              />
            </FormField>
          </Box>
        </Box>
      </Box>
    </StackLayout>
  );
}
